// extracted by mini-css-extract-plugin
export default {"tooltipWrapper":"bY-z","tooltip":"cY-z","tooltipContent":"dY-z","orderStatusWrapper":"eY-z"};